import { useMutation } from '@tanstack/react-query'

import { useMe } from '@shared/providers/src/MeProvider'
import { setQueriesData } from '@shared/providers/src/QueryClientProvider'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export function usePictureUpdate() {
  const me = useMe()

  return useMutation({
    mutationFn: (data) => API.users.id(me.id).photo.update(data),
    onSuccess: ({ url }) =>
      setQueriesData({ queryKey: QK.me(me.id).details }, (current) => ({
        ...current,
        profilePictureUrl: url,
        profilePictureThumbUrl: url,
      })),
  })
}

export function usePictureRemove() {
  const me = useMe()

  return useMutation({
    mutationFn: () => API.users.id(me.id).photo.remove(),
    onSuccess: () =>
      setQueriesData({ queryKey: QK.me(me.id).details }, (current) => ({
        ...current,
        profilePictureUrl: undefined,
        profilePictureThumbUrl: undefined,
      })),
  })
}
